// F4 Report 2: 3D Discussion
import React, { useEffect, useState } from "react";
import { fetchReport3DDiscussion } from "../../api/service";
import ReportShell, { display, downloadReportCsv } from "./ReportShell";

const ThreeDDiscussionReport = () => {
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    fetchReport3DDiscussion()
      .then((res) => {
        if (!alive) return;
        setRows(res?.rows || []);
        setCount(res?.count || 0);
      })
      .catch((e) => alive && setError(e?.message || "Failed to load"))
      .finally(() => alive && setLoading(false));
    return () => { alive = false; };
  }, []);

  return (
    <ReportShell
      title="2. 3D Discussion"
      count={count}
      loading={loading}
      error={error}
      onExport={() => downloadReportCsv("3d_discussion")}
    >
      <div className="table-responsive">
        <table className="table table-bordered table-hover align-middle">
          <thead className="table-light">
            <tr>
              <th className="text-center">Project</th>
              <th className="text-center">Design Members</th>
              <th className="text-center">Ageing (days)</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr><td colSpan={3} className="text-center text-muted py-4">No projects in this stage.</td></tr>
            ) : rows.map((r) => (
              <tr key={r.project_id}>
                <td className="text-center">{r.project_label}</td>
                <td className="text-center">{display(r.design_members)}</td>
                <td className="text-center">{display(r.ageing_days)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </ReportShell>
  );
};

export default ThreeDDiscussionReport;
